<template>
    <div>
        <az-back-button :route="{name: 'licitacaoBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <licitacao-fornecedor-acoes ref="fornecedor-acoes"></licitacao-fornecedor-acoes>
            <div class="az-tabs">
                <v-tabs left>
                    <v-tab :to="construirRota(abas.dadosGerais.nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{abas.dadosGerais.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.edital.nomeRota)" active-class="v-tabs__item--active secondary--text">
                        {{abas.edital.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.esclarecimentoImpugnacao.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
                        {{abas.esclarecimentoImpugnacao.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.lotesItens.nomeRota)" v-if="!termoAceiteProposta" active-class="v-tabs__item--active secondary--text">
                        {{abas.lotesItens.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.propostaItens.nomeRota)" v-if="termoAceiteProposta" active-class="v-tabs__item--active secondary--text">
                        {{abas.propostaItens.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.documentos.nomeRota)" v-if="termoAceiteProposta" active-class="v-tabs__item--active secondary--text">
                        {{abas.documentos.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.propostasReadequacao.nomeRota)" v-if="termoAceiteProposta" active-class="v-tabs__item--active secondary--text">
                        {{abas.propostasReadequacao.titulo}}
                    </v-tab>
                    <v-tab :to="construirRota(abas.recursoContrarrazao.nomeRota)" v-if="!licitacao.ehPerfilComprasBR && licitacao.executarLicitacao" active-class="v-tabs__item--active secondary--text">
                      {{abas.recursoContrarrazao.titulo}}
                    </v-tab>
                </v-tabs>
                <router-view @termosAceitos="termosAceitos"></router-view>
            </div>
        </az-container>
    </div>
</template>

<script>
    import {actionTypes} from '@/commons/constants'
    import {mapActions, mapState} from 'vuex'
    import LicitacaoFornecedorAcoes from './acoes/LicitacaoFornecedorAcoes'

    export default {
        name: 'LicitacaoFornecedor',
        components: {LicitacaoFornecedorAcoes},
        data() {
            return {
                abas: {
                    dadosGerais: {
                        titulo: 'Dados da Licitação',
                        nomeRota: 'licitacaoFornecedorDadosGerais'
                    },
                    edital: {
                        titulo: 'Dados do Edital',
                        nomeRota: 'licitacaoFornecedorEdital'
                    },
                    esclarecimentoImpugnacao: {
                        titulo: 'Esclarecimento/Impugnação',
                        nomeRota: 'licitacaoFornecedorEsclarecimentoImpugnacao'
                    },
                    recursoContrarrazao: {
                        titulo: 'Recurso/Contrarrazão',
                        nomeRota: 'licitacaoFornecedorRecursoContrarrazao'
                    },
                    lotesItens: {
                        titulo: 'Itens',
                        nomeRota: 'licitacaoFornecedorItens'
                    },
                    propostaItens: {
                        titulo: 'Lotes/Itens',
                        nomeRota: 'licitacaoFornecedorProposta'
                    },
                    documentos: {
                        titulo: 'Documentos',
                        nomeRota: 'licitacaoFornecedorDocumentos'
                    },
                    propostasReadequacao: {
                        titulo: 'Minhas Propostas',
                        nomeRota: 'licitacaoFornecedorReadequacaoProposta'
                    }
                },
                isPropostaIniciada: false,
                licitacaoId: undefined,
                termosProposta: undefined
            }
        },
        computed: {
            ...mapState(['loki', 'termoAceiteProposta', 'licitacao'])
        },
        async beforeRouteUpdate(to, from, next) {
            if (this.loki.user.domainId) {
                await this.buscarDadosProposta()
            }
            next()
        },
        async created() {
            this.setLicitacaoId(this.$route.params.id)
            await this.buscarDadosProposta()
        },
        methods: {
            async termosAceitos(){
              await this.$refs["fornecedor-acoes"].buscarAceiteTermo()
            },
            construirRota(name) {
                return {
                    name,
                    params: {id: this.licitacaoId}
                }
            },
            async buscarDadosProposta() {
                this.setMensagemLoading('Carregando dados da Proposta...')
                await this.buscarPropostaResumo(this.licitacaoId)
                this.validarLicitacaoPublicada()
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            validarLicitacaoPublicada(){
              if(!this.licitacao.publicado){
                this.$router.push({name: 'licitacaoBuscaMsg', params: {tipo: 'licitacaoexcluida'}})
              }
            },
            ...mapActions([actionTypes.BUSCAR_PROPOSTA_RESUMO])
        },
        timers: {
            buscarDadosProposta: {
                time: 30000,
                repeat: true,
                autostart: true
            }
        }
    }
</script>
